import { Pipe, PipeTransform } from '@angular/core';
import { formatMoneyDisplay } from 'src/shared/lib/money';

@Pipe({
  name: 'formatNumber',
  standalone: true,
})
export class FormatNumberPipe implements PipeTransform {
  transform(value: number | string | null | undefined): string {
    if (value == null || value === '') return '';
    const truncated = formatMoneyDisplay(value);
    if (truncated === '0.00' && !Number.isFinite(Number(value))) return '';
    const negative = truncated.startsWith('-');
    const [whole, frac] = truncated.replace('-', '').split('.');
    const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return `${negative ? '-' : ''}${grouped}.${frac}`;
  }
}
